<div class="gm-game gm-ms">
  <div class="gm-game-bar">
    <span class="gm-game-title">Minesweeper</span>
    <div class="gm-game-actions">
      <span class="gm-stat">💣 <b>{{ minesLeft() }}</b></span>
      <button class="gm-btn" (click)="reset()">{{ state() === 'play' ? 'New' : 'Retry' }}</button>
    </div>
  </div>
  <div class="gm-game-body">
    <div class="gm-levels">
      @for (lv of levels; track lv.id) {
        <button class="gm-lvl" [class.on]="level() === lv.id" (click)="changeLevel(lv.id)">
          <span class="gm-lvl-name">{{ lv.label }}</span>
          <span class="gm-lvl-sub">{{ lv.sub }}</span>
        </button>
      }
    </div>
    <div class="ms-scroll">
      <div class="ms-grid" [style.gridTemplateColumns]="gridCols()" (contextmenu)="$event.preventDefault()">
        @for (c of cells(); track $index) {
          <button
            class="ms-cell"
            [class.rev]="c.rev"
            [class.boom]="c.rev && c.mine"
            [style.width.px]="cell()"
            [style.height.px]="cell()"
            [style.fontSize.px]="fontSize()"
            (mousedown)="onDown($index, $event)"
            (mouseup)="onUp($index, $event)"
            (mouseleave)="onLeave()"
            (touchstart)="onDown($index, $event)"
            (touchend)="onTouchEnd($index, $event)"
            (contextmenu)="flag($event, $index)">
            @if (c.rev) {
              @if (c.mine) {
                💣
              } @else if (c.adj) {
                <span [style.color]="numColor[c.adj]">{{ c.adj }}</span>
              }
            } @else if (c.flag) {
              🚩
            }
          </button>
        }
      </div>
    </div>
    @if (state() !== 'play') {
      <div class="gm-win" [class.lose]="state() === 'lost'">
        {{ state() === 'won' ? 'Cleared! 🎉' : 'Boom 💥' }}
        <button class="gm-btn primary" (click)="reset()">Again</button>
      </div>
    }
  </div>
</div>
